<template>
    <div>
        <div>
            <span v-if="showTitle" class="text-primary">{{ $t(title) }}</span>
            <div class="bs-component">
                <div class="btn-group float-left">
                    <template v-if="enableOverCheck && !checkboxColumnDisabled && (!isModal || modalCheckEnable)">
                        <mmf-button
                            type="search"
                            :customIcon="isOverCheckTableViewing ? 'fa fa-solid fa-arrow-up-from-bracket' : 'fa fa-solid fa-check-double'"
                            :disabled="actionDisabled('delete') && !isOverCheckTableViewing"
                            class="btn"
                            :class="isOverCheckTableViewing ? 'btn-primary' : 'btn-outline-primary'"
                            @click="overCheckButtonClick"
                        ></mmf-button>
                    </template>
                    <!--  编辑按钮(增删改): 未禁用编辑,则可进一步判断-->
                    <template v-if="!editDisable">
                        <!-- 新增：跳转：行编辑禁用,或使用的el组件，则显示-->
                        <template v-if="inlineActionsDisabled || baseComponent === 'el'">
                            <mmf-button key="entityAddNewButton" v-if="!ignoreAdd && !headerBtnAddDisabled"
                                        type="add" v-bind:class="'btn btn-outline-primary btn-sm'"
                                        v-menu-permission="'new'"
                                        v-on:click="clickAddNewEntityButton"></mmf-button>
                        </template>
                        <!-- 新增：行编辑: 行编辑未禁用则显示-->
                        <template v-else>
                            <mmf-button key="entityAddNewInlineButton"
                                        type="add" v-bind:class="'btn btn-outline-primary btn-sm'"
                                        v-menu-permission="'new'"
                                        v-on:click="addRow"></mmf-button>
                        </template>
                        <!-- 修改：跳转：未禁用行选择,且禁用了行编辑，则显示表编辑按钮 -->
                        <template v-if="!checkboxColumnDisabled && inlineActionsDisabled">
                            <mmf-button
                                key="entityEditButton"
                                v-if="!headerBtnEditDisabled"
                                type="edit"
                                v-bind:class="'btn btn-outline-primary btn-sm'"
                                v-menu-permission="'edit'"
                                :disabled="actionDisabled('edit')"
                                v-on:click="clickEditEntityButton"
                            ></mmf-button>
                        </template>
                        <!-- 删除：未禁用行选择,则显示删除按钮(与表编辑按钮的区别在于:就算是行编辑,也可以保留批量删除按钮) -->
                        <template v-if="!checkboxColumnDisabled && !ignoreDelete">
                            <mmf-button
                                key="entityDeleteButton"
                                v-if="!headerBtnDelDisabled"
                                type="delete"
                                v-bind:class="'btn btn-outline-primary btn-sm'"
                                :disabled="actionDisabled('delete')"
                                v-menu-permission="'delete'"
                                :busy="onDeleting"
                                v-on:click="handleDelete"
                            ></mmf-button>
                        </template>
                    </template>
                    <slot name="left-header"></slot>
                </div>
            </div>
            <!--      <div class="col-lg-12">-->
            <div class="float-lg-right btn-group">
                <template v-if="enableFieldBatchEdit">
                    <b-dropdown variant="outline-primary"
                                :disabled="checkedItems.length===0 || batchEditSaveLoading">
                        <template #button-content>
                            <b-spinner small v-if="batchEditSaveLoading"></b-spinner>
                            批量操作
                        </template>
                        <template v-for="(item,index) of activeEditFields">
                            <b-dropdown-item :key="index"
                                             @click="openBatchEditModal(item)">
                                修改 {{ item.label }}
                            </b-dropdown-item>
                        </template>
                    </b-dropdown>
                </template>
                <!-- 导入按钮 -->
                <template v-if="importEnabled">
                    <mmf-button v-menu-permission="'edit'"
                                type="import"
                                :busy="importLoading"
                                v-bind:class="'btn btn-outline-primary'"
                                v-on:click="tableImport(entity)"
                    ></mmf-button>
                </template>
                <!-- 导出按钮 -->
                <template v-if="!exportDisabled">
                    <mmf-button
                        type="export"
                        v-bind:class="'btn btn-outline-primary'"
                        v-on:click="tableExport(entity)"
                    ></mmf-button>
                </template>
                <!-- 回上级按钮 -->
                <template v-if="parentLevel">
                    <mmf-button
                        type="gotoGrandParent"
                        v-bind:class="'btn btn-outline-primary'"
                        v-on:click="gotoGrandParentLevel"
                    ></mmf-button>
                </template>
                <!-- 自定义列 -->
                <template v-if="!customizationDisabled">
                    <mmf-button
                        type="add"
                        custom-icon="fa fa-fw fa-lg fa-sliders"
                        v-bind:class="'btn btn-outline-primary'"
                        v-on:click="openCustomization"
                    ></mmf-button>
                </template>
                <!-- 图表生成器 -->
                <template v-if="enableChartGenerator">
                    <mmf-button
                        type="search"
                        custom-icon="fa fa-fw fa-lg fa-solid fa-chart-line"
                        v-bind:class="'btn btn-outline-primary'"
                        v-on:click="openChartGenerator"
                    ></mmf-button>
                </template>
                <slot name="right-header"></slot>
            </div>
            <!--      </div>-->
            <!--空出修改、删除、导出按钮的位置-->
            <div class="clearfix">&nbsp;</div>
            <div :class="getFixedHeaderTopDivClass()">
                <b-spinner label="Spinning" small variant="primary" class="position-absolute top right m-2"
                           style="z-index: 10;" v-show="sortLoading>0"></b-spinner>
                <!-- 固定表头，可以让表具有上下滚动条，如果去掉，表就一直往下撑。-->
                <div v-if="baseComponent === 'mmf'" :class="getFixedHeaderCantainerClass()">
                    <table class="table table-hover" :class="tableCoverClass">
                        <!-- 表头 -->
                        <thead>
                        <tr>
                            <th v-for="col in tableColumns" v-bind:key="col.key"
                                @mousedown="onHeaderMouseDown($event)" @click="sortColumn(col, $event)"
                                :class="getTableColumnClass(col)">
                                <!-- 下面这行屏蔽掉，貌似没啥影响，表头还是可以固定，表身可以滚动 -->
                                <!--                  {{ $t(col.label) }}-->
                                <!--全选-->
                                <div scope="col" v-if="col.form.type === 'checkbox'"
                                     style="margin-left:0px;width:20px;">
                                    <b-form-checkbox @click.native.stop @change="toggleAll" inline
                                                     style="width:20px;"/>
                                </div>
                                <!--行首插槽-->
                                <div scope="col" v-if="col.form.type === 'customRowActionsFirstColumn'"
                                     style="margin-left:auto">
                                    {{ customRowActionsTextFirstColumn }}
                                </div>
                                <!--普通表头-->
                                <div scope="col" v-else>
                                    {{ $t(col.label) }}
                                    <!--排序箭头-->
                                    <i :class="getSortedState(getColumnOriginKey(col))"></i>
                                </div>
                            </th>
                            <th v-if="isCustomRowActionsDisplay()">
                                {{ customRowActionsText }}
                                <div scope="col">{{ customRowActionsText }}</div>
                            </th>
                        </tr>
                        </thead>
                        <!-- 新纪录 -->
                        <tbody v-if="newRows.length > 0 && !isModal">
                        <tr v-for="(row, index) in newRows" v-bind:key="index">
                            <td v-for="col in tableColumns" v-bind:key="col.key">
                                <div v-if="col.form.type === 'checkbox'"></div>
                                <div v-else-if="col.form.type === 'modalEdit'">
                                    <b-btn
                                        v-if="isRowEditing(row)"
                                        size="sm"
                                        @click="showModalEditValue({action:'edit', scope:'add'}, row, col)"
                                    >Edit
                                    </b-btn>
                                    <b-btn
                                        v-else
                                        size="sm"
                                        @click="showModalEditValue({action:'view', scope:'add'}, row, col)"
                                    >Show
                                    </b-btn>
                                </div>
                                <div v-else-if="col.form.type === 'inlineActions'" class="btn-group">
                                    <mmf-button
                                        type="cancel"
                                        v-bind:class="'btn btn-outline-secondary btn-sm'"
                                        v-on:click="cancelAddedRow(row)"
                                    ></mmf-button>
                                    <mmf-button
                                        type="save"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        v-on:click="saveAddedRow(row)"
                                    ></mmf-button>
                                </div>
                                <div v-else>
                                    <mmf-form-helper
                                        :entity="entity"
                                        :metadata="col"
                                        :isEditing="isRowEditing(row)"
                                        :value="row[col.key]"
                                        @input="changeNewEntityAttribute(col, row, $event)"
                                        @selectModalEntity="showModalSelectorByNewRow(col,row)"
                                        @selectMultipleModalEntity="showModalMultipleSelectorByNewRow(col,row)"
                                        @bind="changeNewEntityAttribute(col,row, $event)"
                                        @keypress.enter.native="saveAddedRow(row)"
                                    ></mmf-form-helper>
                                </div>
                            </td>
                            <!-- 新记录，好像不应该显示行插槽的内容，显示了也不一定好使，所以先弄个空的占位 -->
                            <td v-if="isCustomRowActionsDisplay"></td>
                        </tr>
                        </tbody>
                        <!-- 现有记录 -->
                        <tbody v-if="!showNoResultAlert">
                        <tr class="td-cover"
                            :class="!disableCheckedColorChange && isChecked(row) ? 'table-primary' : ''"
                            v-for="row in rows" v-bind:key="row.id">
                            <!--行首插槽-->
                            <!--              <td v-if="withCustomRowActionsFirstColumn">-->
                            <!--                &lt;!&ndash; 作用域具名插槽，可自定义列表项按钮 &ndash;&gt;-->
                            <!--                <slot name="customRowActionsFirstColumn" :row="row"></slot>-->
                            <!--              </td>-->
                            <td v-for="col in tableColumns" v-bind:key="col.key">
                                <!--特殊列-->
                                <!--行选择 -->
                                <div v-if="col.form.type === 'checkbox'">
                                    <b-form-checkbox
                                        @click.native.stop
                                        :checked="isChecked(row)"
                                        @change="emBaseSelectRow({item: row, entity,entityState:$_emCustomVuexMixin_entity,voState:$_emCustomVuexMixin_vo})"
                                        :disabled="isRowEditing(row)"
                                        inline
                                        style="width:20px"/>
                                </div>
                                <!--行首插槽-->
                                <div v-else-if="col.form.type === 'customRowActionsFirstColumn'">
                                    <!-- 作用域具名插槽，可自定义列表项按钮 -->
                                    <slot name="customRowActionsFirstColumn" :row="row"></slot>
                                </div>
                                <div v-else-if="col.form.type === 'modalEdit'">
                                    <b-btn
                                        v-if="isRowEditing(row)"
                                        size="sm"
                                        @click="showModalEditValue({action:'edit', scope:'edit'}, row, col)">
                                        Edit
                                    </b-btn>
                                    <b-btn
                                        v-else
                                        size="sm"
                                        @click="showModalEditValue({action:'view', scope:'edit'}, row, col)">
                                        Show
                                    </b-btn>
                                </div>
                                <!--流程状态-->
                                <div v-else-if="col.form.type === 'processingStatus'">
                                    <mmf-icon :type="getProcessingType(row, col)"></mmf-icon>
                                </div>
                                <div v-else-if="col.form.type === 'log'">
                                    <div v-if="getLogAvailable(row, col)">
                                        <mmf-button type="log" v-on:click="downloadLog(row)"></mmf-button>
                                    </div>
                                    <div v-else>-</div>
                                </div>
                                <!--行编辑-->
                                <div v-else-if="col.form.type === 'inlineActions'">
                                    <!-- 如果该行处于编辑状态 -->
                                    <div v-if="isRowEditing(row)">
                                        <mmf-button
                                            type="cancel"
                                            v-bind:class="'btn btn-outline-secondary btn-sm'"
                                            v-on:click="cancelRowEdit(row)"
                                        ></mmf-button>
                                        <mmf-button
                                            type="save"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            v-on:click="saveEditedRow(row)"
                                            v-menu-permission="'edit'"
                                        ></mmf-button>
                                    </div>
                                    <!-- 否则 -->
                                    <div class="btn-group" v-else>
                                        <mmf-button v-show="!inlineActionsDisabled && !editDisable"
                                                    type="edit"
                                                    v-bind:class="'btn btn-outline-primary btn-sm'"
                                                    v-menu-permission="'edit'"
                                                    v-on:click="editRow(row)"
                                        ></mmf-button>
                                        <mmf-button v-show="!inlineActionsDisabled && !editDisable"
                                                    type="delete"
                                                    v-bind:class="'btn btn-outline-primary btn-sm'"
                                                    v-menu-permission="'delete'"
                                                    v-on:click="delRow(row)"
                                                    :busy="onDeleting"
                                        ></mmf-button>
                                        <mmf-button v-show="!detailInlineButtonDisable"
                                                    :type="getDetailInlineButtonType(row)"
                                                    v-bind:class="'btn btn-outline-primary btn-sm'"
                                                    @click="showEntity(row)"
                                        ></mmf-button>
                                    </div>
                                </div>
                                <div v-else-if="col.form.type === 'entityModalSelectAction'">
                                    <div class="btn-group">
                                        <b-form-checkbox
                                            v-if="modalCheckEnable"
                                            @click.native.stop
                                            :checked="isChecked(row)"
                                            @change="emBaseSelectRow({item: row, entity,entityState:$_emCustomVuexMixin_entity,voState:$_emCustomVuexMixin_vo})"
                                            :disabled="isRowEditing(row)"
                                            inline
                                            style="width:20px"/>
                                        <mmf-button
                                            v-else
                                            type="save"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            v-on:click="selectRow(row)"
                                        ></mmf-button>
                                    </div>
                                </div>
                                <!--                  普通数据-->
                                <div v-else>
                                    <!-- 如果该行处于编辑状态 -->
                                    <div v-if="isRowEditing(row)">
                                        <!--注意：这里一定要绑定editingRow，否则vuex中的editingRow数据更新了，前台体现不出来，例如modelEntitySelect选中记录后-->
                                        <mmf-form-helper
                                            :entity="entity"
                                            :metadata="col"
                                            :isEditing="isRowEditing(row)"
                                            :value="visitateProperty(getEditingRowById(row.id),col.key)"
                                            :self-row="getEditingRowById(row.id)"
                                            @input="changeEditEntityAttribute(col, row, $event)"
                                            @selectModalEntity="showModalSelectorByEditRow(col,row)"
                                            @selectMultipleModalEntity="showModalMultipleSelectorByEditRow(col,row)"
                                            @bind="changeEditEntityAttribute(col,row, $event)"
                                            @keypress.enter.native="saveEditedRow(row)"
                                        ></mmf-form-helper>
                                    </div>
                                    <div v-else>
                                        <mmf-form-helper
                                            :ref="`view_cell_${row.id}_${col.key}`"
                                            :class="customClass(col,row)"
                                            :format-cell-value="formatCellValue"
                                            :metadata="col"
                                            :isEditing="isRowEditing(row)"
                                            :value="visitateProperty(row, col.key)"
                                            :self-row="row"
                                            @linkClick="$emit('linkClick', col.key, row, $event)"
                                        ></mmf-form-helper>
                                    </div>
                                </div>
                            </td>
                            <td v-if="isCustomRowActionsDisplay()">
                                <!-- 作用域具名插槽，可自定义列表项按钮 -->
                                <slot name="customRowActions" :row="row"></slot>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <mmf-no-result-alert :isVisible="showNoResultAlert"></mmf-no-result-alert>
                </div>
                <el-table v-else-if="baseComponent === 'el'" :data="rows" stripe max-height="1000" highlight-current-row
                          row-key="id" border
                          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                          @selection-change="handleSelectionChange" @select="handleSelect"
                          @sort-change="handleSortChange"
                          default-expand-all
                          v-fit-columns>
                    <!--          :row-style="{height: '0'}"-->
                    <!--          :cell-style="{padding: '0'}"-->
                    <!--多选-->
                    <el-table-column
                        fixed
                        type="selection"
                        width="55">
                    </el-table-column>
                    <!--编号-->
                    <!--          <el-table-column-->
                    <!--              label="编号"-->
                    <!--              fixed-->
                    <!--              type="index"-->
                    <!--              width="55">-->
                    <!--          </el-table-column>-->

                    <!--数据-->
                    <!--          <el-table-column v-for="col in tableColumns.filter(f => !f.isActionField && !f.isControlField)"-->
                    <!--                           v-bind:key="col.key+tableColumnsVersion"-->
                    <!--                           :prop="col.key"-->
                    <!--                           :label="$t(col.label)"-->
                    <!--                           sortable="custom"-->
                    <!--                           :filters="getColumnFilters(col.key)"-->
                    <!--                           :filter-method="filterHandler"-->
                    <!--          >-->
                    <!--          </el-table-column>-->
                    <!--formHelper数据-->
                    <el-table-column v-for="col in tableColumns.filter(f => !f.isActionField && !f.isControlField)"
                                     v-bind:key="col.key+tableColumnsVersion"
                                     :label="$t(col.label)"
                                     :prop="col.key"
                                     sortable="custom"
                                     :filters="getColumnFilters(col.key)"
                                     :filter-method="filterHandler"
                                     v-fit-columns>
                        <!--            show-overflow-tooltip-->
                        <!--            <template slot-scope="scope">-->
                        <!--              &lt;!&ndash;行首插槽&ndash;&gt;-->
                        <!--              <div v-if="col.form.type === 'customRowActionsFirstColumn'">-->
                        <!--                &lt;!&ndash; 作用域具名插槽，可自定义列表项按钮 &ndash;&gt;-->
                        <!--                <slot name="customRowActionsFirstColumn" :row="scope.row"></slot>-->
                        <!--              </div>-->
                        <!--              <div v-else-if="col.form.type === 'modalEdit'">-->
                        <!--                <b-btn-->
                        <!--                    v-if="isRowEditing(scope.row)"-->
                        <!--                    size="sm"-->
                        <!--                    @click="showModalEditValue({action:'edit', scope:'edit'}, scope.row, col)"-->
                        <!--                >Edit-->
                        <!--                </b-btn>-->
                        <!--                <b-btn-->
                        <!--                    v-else-->
                        <!--                    size="sm"-->
                        <!--                    @click="showModalEditValue({action:'view', scope:'edit'}, scope.row, col)"-->
                        <!--                >Show-->
                        <!--                </b-btn>-->
                        <!--              </div>-->
                        <!--              &lt;!&ndash;流程状态&ndash;&gt;-->
                        <!--              <div v-else-if="col.form.type === 'processingStatus'">-->
                        <!--                <mmf-icon :type="getProcessingType(scope.row, col)"></mmf-icon>-->
                        <!--              </div>-->
                        <!--              <div v-else-if="col.form.type === 'log'">-->
                        <!--                <div v-if="getLogAvailable(scope.row, col)">-->
                        <!--                  <mmf-button type="log" v-on:click="downloadLog(scope.row)"></mmf-button>-->
                        <!--                </div>-->
                        <!--                <div v-else>-</div>-->
                        <!--              </div>-->
                        <!--              &lt;!&ndash;行编辑&ndash;&gt;-->
                        <!--              <div v-else-if="col.form.type === 'inlineActions'">-->
                        <!--                &lt;!&ndash; 如果该行处于编辑状态 &ndash;&gt;-->
                        <!--                <div v-if="isRowEditing(scope.row)">-->
                        <!--                  <mmf-button-->
                        <!--                      type="cancel"-->
                        <!--                      v-bind:class="'btn btn-outline-secondary btn-sm'"-->
                        <!--                      v-on:click="cancelRowEdit(scope.row)"-->
                        <!--                  ></mmf-button>-->
                        <!--                  <mmf-button-->
                        <!--                      type="save"-->
                        <!--                      v-bind:class="'btn btn-outline-primary btn-sm'"-->
                        <!--                      v-on:click="saveEditedRow(scope.row)"-->
                        <!--                      v-menu-permission="'edit'"-->
                        <!--                  ></mmf-button>-->
                        <!--                </div>-->
                        <!--                &lt;!&ndash; 否则 &ndash;&gt;-->
                        <!--                <div class="btn-group" v-else>-->
                        <!--                  <mmf-button v-show="!inlineActionsDisabled && !editDisable"-->
                        <!--                              type="edit"-->
                        <!--                              v-bind:class="'btn btn-outline-primary btn-sm'"-->
                        <!--                              v-menu-permission="'edit'"-->
                        <!--                              v-on:click="editRow(scope.row)"-->
                        <!--                  ></mmf-button>-->
                        <!--                  <mmf-button v-show="!inlineActionsDisabled && !editDisable"-->
                        <!--                              type="delete"-->
                        <!--                              v-bind:class="'btn btn-outline-primary btn-sm'"-->
                        <!--                              v-menu-permission="'edit'"-->
                        <!--                              v-on:click="delRow(scope.row)"-->
                        <!--                              :busy="onDeleting"-->
                        <!--                  ></mmf-button>-->
                        <!--                  <mmf-button v-show="!detailInlineButtonDisable"-->
                        <!--                              type="showEntity"-->
                        <!--                              v-bind:class="'btn btn-outline-primary btn-sm'"-->
                        <!--                              @click="showEntity(scope.row)"-->
                        <!--                  ></mmf-button>-->
                        <!--                </div>-->
                        <!--              </div>-->
                        <!--              <div v-else-if="col.form.type === 'entityModalSelectAction'">-->
                        <!--                <div class="btn-group">-->
                        <!--                  <mmf-button-->
                        <!--                      type="save"-->
                        <!--                      v-bind:class="'btn btn-outline-primary btn-sm'"-->
                        <!--                      v-on:click="selectRow(scope.row)"-->
                        <!--                  ></mmf-button>-->
                        <!--                </div>-->
                        <!--              </div>-->
                        <!--              &lt;!&ndash;                  普通数据&ndash;&gt;-->
                        <!--              <div v-else>-->
                        <!--                &lt;!&ndash; 如果该行处于编辑状态 &ndash;&gt;-->
                        <!--                <div v-if="isRowEditing(scope.row)">-->
                        <!--                  &lt;!&ndash;注意：这里一定要绑定editingRow，否则vuex中的editingRow数据更新了，前台体现不出来，例如modelEntitySelect选中记录后&ndash;&gt;-->
                        <!--                  <mmf-form-helper-->
                        <!--                      :metadata="col"-->
                        <!--                      :isEditing="isRowEditing(scope.row)"-->
                        <!--                      :value="visitateProperty(getEditingRowById(scope.row.id),col.key)"-->
                        <!--                      @input="changeEditEntityAttribute(col, scope.row, $event)"-->
                        <!--                      @selectModalEntity="showModalSelectorByEditRow(col,scope.row)"-->
                        <!--                      @bind="changeEditEntityAttribute(col,scope.row, $event)"-->
                        <!--                      @keypress.enter.native="saveEditedRow(scope.row)"-->
                        <!--                  ></mmf-form-helper>-->
                        <!--                </div>-->
                        <!--                <div v-else>-->
                        <!--                  <mmf-form-helper-->
                        <!--                      :class="customClass(col,scope.row)"-->
                        <!--                      :metadata="col"-->
                        <!--                      :isEditing="isRowEditing(scope.row)"-->
                        <!--                      :value="visitateProperty(scope.row, col.key)"-->
                        <!--                  ></mmf-form-helper>-->
                        <!--                </div>-->
                        <!--              </div>-->
                        <!--            </template>-->
                    </el-table-column>
                    <!--功能-->
                    <el-table-column v-for="col in tableColumns.filter(f => f.form && f.form.type === 'inlineActions')"
                                     v-bind:key="col.key"
                                     fixed="right"
                                     :prop="col.key"
                                     :label="$t(col.label)">
                        <template slot-scope="scope">
                            <!-- 如果该行处于编辑状态 -->
                            <div v-if="isRowEditing(scope.row)">
                                <mmf-button
                                    type="cancel"
                                    v-bind:class="'btn btn-outline-secondary btn-sm'"
                                    v-on:click="cancelRowEdit(scope.row)"
                                ></mmf-button>
                                <mmf-button
                                    type="save"
                                    v-bind:class="'btn btn-outline-primary btn-sm'"
                                    v-on:click="saveEditedRow(scope.row)"
                                    v-menu-permission="'edit'"
                                ></mmf-button>
                            </div>
                            <!-- 否则 -->
                            <div class="btn-group" v-else>
                                <mmf-button v-show="!inlineActionsDisabled && !editDisable"
                                            type="edit"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            v-menu-permission="'edit'"
                                            v-on:click="editRow(scope.row)"
                                ></mmf-button>
                                <mmf-button v-show="!inlineActionsDisabled && !editDisable"
                                            type="delete"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            v-menu-permission="'delete'"
                                            v-on:click="delRow(scope.row)"
                                            :busy="onDeleting"
                                ></mmf-button>
                                <mmf-button v-show="!detailInlineButtonDisable"
                                            type="showEntity"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            @click="showEntity(scope.row)"
                                ></mmf-button>
                            </div>
                        </template>
                    </el-table-column>
                    <!--          行尾插槽-->
                    <el-table-column v-if="isCustomRowActionsDisplay()"
                                     v-bind:key="'customRowActions'+tableColumnsVersion"
                                     label="额外功能"
                                     fixed="right">
                        <template slot-scope="scope">
                            <!-- 作用域具名插槽，可自定义列表项按钮 -->
                            <slot name="customRowActions" :row="scope.row"></slot>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <em-pagination
                v-show="!showNoResultAlert"
                :entity="entity"
                :totalRows="totalRows"
                :ignoreMaxTableItemLimit="ignoreMaxTableItemLimit"
                :perPage="rowsPerPage"
                :currentPage="currentPage"
                :filter-state="$_emCustomVuexMixin_filter"
                :load-state="$_emCustomVuexMixin_vo"
                :query-api="queryApi"
                v-on:change:perpage="rowsPerPage = $event"
                v-on:change:page="currentPage = $event"
                @doPagination="doPagination"
            ></em-pagination>
        </div>
        <form id="my_form"></form>
        <!--        <mmf-no-result-alert :isVisible="showNoResultAlert"></mmf-no-result-alert>-->
        <b-modal
            ref="modalViewer"
            centered
            :title="modelEditColumnLabel"
            size="lg"
            ok-only
            :ok-title="$t('lbl.basic.close')">
            <b-card>
                <b-row class="mb-2">
                    <p class="my-4">{{ modalEditValue }}</p>
                </b-row>
            </b-card>
        </b-modal>
        <b-modal
            ref="modalEditor"
            centered
            :title="modelEditColumnLabel"
            size="lg"
            :ok-title="$t('btn.basic.save')"
            :cancel-title="$t('lbl.basic.cancel')"
            @ok="saveModalEditValue">
            <div class="d-block text-center">
                <textarea v-model="modalEditValue" style="width: 100%" rows="15"/>
            </div>
        </b-modal>
        <!--    自定义列-->
        <!--    <b-modal-->
        <!--        ref="modalCustomization"-->
        <!--        centered-->
        <!--        :title="modelEditColumnLabel"-->
        <!--        size="lg"-->
        <!--        :ok-title="$t('btn.basic.save')"-->
        <!--        :cancel-title="$t('lbl.basic.cancel')"-->
        <!--        @ok="saveCustomization"-->
        <!--    >-->
        <!--      <div>咋不显示呢</div>-->
        <Customization ref="Customization" :vuexFieldConfigs="vuexFieldConfigs"
                       :localstorageFieldConfigsKey="localstorageFieldConfigsKey"
                       @customizationSave="tableColumnsReload"></Customization>
        <!--    </b-modal>-->
        <em-modal-entity-viewer
            :title="title"
            ref="modalEntityViewer"
            :entity="entity"
            :object="entityObject"
            :$_em-custom-vuex-mixin_configs="$_emCustomVuexMixin_voName"
        ></em-modal-entity-viewer>
        <em-table-export
            :entity="entity"
            :filterState="this.$_emCustomVuexMixin_filter"
            :queryApi="getTableExportUrl()"
            :useCustomFieldsDefaultFlag="useCustomFieldsDefaultFlag"
            ref="exportConfirm"
            :config="{perPageSize:rowsPerPage, totalRows, customFieldList:tableColumns}"
            :customVuexName=customVuexName
        ></em-table-export>
        <em-table-import
            ref="importConfirm"
            :entity="entity"
            @begin="importLoading=true"
            @end="importLoading=false">
        </em-table-import>
        <over-select ref="overCheck" @needTableView="isOverCheckTableViewing = true"></over-select>
        <re-b-modal ref="table_chart_configure_modal" v-if="enableChartGenerator" large centered clean>
            <table-chart-configure ref="table_chart"></table-chart-configure>
        </re-b-modal>

        <re-b-modal ref="batchEdit"
                    :header="'修改'+currentBatchEditingField.label"
                    no-auto-hide
                    :ok-loading="batchEditSaveLoading"
                    @ok="saveBatchEdit"
                    @hide="clearBatchEdit">
            <em-form-helper v-if="currentBatchEditingField && currentBatchEditingField.key" is-editing
                            :name="currentBatchEditingField.key"
                            :metadata="currentBatchEditingField.config"
                            :value="currentBatchEditingData"
                            :entity="entity"
                            @input="changeBatchEditingData"/>
        </re-b-modal>
    </div>
</template>


<script>
import MmfButton from "@/components/em/EmButton";
import MmfIcon from "@/components/MmfIcon";
import commonViewsUtil from "@/utils/commonViewsUtil";
import levelTreeUtil from "@/utils/levelTreeUtil";
import MmfNoResultAlert from "@/components/MmfNoResultAlert";
import EmPagination from "@/components/em/EmTable/Pagination";
import Customization from "@/components/em/EmTable/Customization";
import MmfFormHelper from "@/components/em/EmFormHelper";
import EmModalEntityViewer from "@/components/em/EmModal/EntityViewer";
import emUtils from "@/utils/emUtils";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import EmTableExport from "@/components/em/EmTable/TableExport";
import EmTableImport from "@/components/em/EmTable/TableImport";

import {mapActions} from "vuex";
import OverSelect from "@/components/em/EmTable/plugins/OverSelect";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import TableChartConfigure from "@/components/echarts-part/TableChart/TableChartConfigure";
import emTableBatchEditMixins from "@/components/em/EmTable/mixins/emTableBatchEditMixins";
import EmFormHelper from "@/components/em/EmFormHelper/index.vue";
import {_getAdditionColumnsByKey} from "@/model/common/addition-table-columns";

let checkboxField = {
    key: "state",
    label: "",
    isControlField: true,
    form: {
        type: "checkbox"
    }
};

let actionField = {
    key: "inlineActions",
    label: "功能",
    isActionField: true,
    form: {
        type: "inlineActions"
    }
};

let selectActionField = {
    key: "selectAction",
    label: "选择",
    isActionField: true,
    form: {
        type: "entityModalSelectAction"
    }
};

let customRowActionsFirstColumnField = {
    key: "customRowActionsFirstColumn",
    label: "行首插槽",
    isActionField: true,
    form: {
        type: "customRowActionsFirstColumn"
    }
};

export default {
    name: "em-table",
    mixins: [emCustomVuexMixin, emTableBatchEditMixins],
    components: {
        EmFormHelper,
        TableChartConfigure,
        ReBModal,
        OverSelect,
        MmfButton,
        MmfIcon,
        MmfNoResultAlert,
        EmPagination,
        Customization,
        MmfFormHelper,
        EmModalEntityViewer,
        EmTableExport,
        EmTableImport
    },
    props: {
        baseComponent: {
            type: String,
            default: 'mmf'
        },
        ignoreMaxTableItemLimit: {
            type: Boolean,
            default: false
        },
        //自定义查询接口，以entity名为前提
        queryApi: {
            type: String,
            default: 'findByFilter'
        },
        tableExportUrl: {
            type: String,
            default: ''
        },
        //禁用编辑
        editDisable: {
            type: Boolean,
            default: false
        },
        //是否弹出，据此选择不同的style样式,以及是弹出，就不渲染编辑状态的行了
        isModal: {
            type: Boolean,
            default: false
        },
        //禁用行内详情按钮
        detailInlineButtonDisable: {
            type: Boolean,
            default: false
        },
        //实体类名
        entity: String,
        //禁用列选择
        checkboxColumnDisabled: {
            type: Boolean,
            default: false
        },
        //忽略删除按钮
        ignoreDelete: {
            type: Boolean,
            default: false
        },
        //忽略新增按钮
        ignoreAdd: {
            type: Boolean,
            default: false
        },
        //启用导入按钮，默认禁用
        importEnabled: {
            type: Boolean,
            default: false
        },
        //禁用导出按钮，默认启用
        exportDisabled: {
            type: Boolean,
            default: false
        },

        //禁用header button的添加按钮
        //2021.8.16 THQ
        headerBtnAddDisabled: {
            type: Boolean,
            default: false
        },
        //禁用header button的删除按钮
        //2021.8.16 THQ
        headerBtnDelDisabled: {
            type: Boolean,
            default: false
        },
        //禁用header button的修改按钮
        //2021.8.16 THQ
        headerBtnEditDisabled: {
            type: Boolean,
            default: false
        },
        //禁用自定义列按钮
        customizationDisabled: {
            type: Boolean,
            default: false
        },
        //需要从表头中排除的字段key。
        //用于同一个 model 被多个页面共用、但某些页面不该看到某些列的场景
        //（例如供应商门户与采购员页面共用 sithMesStoolPrPrice 的 gridFields，
        //  但"发询价人/发询价人员工号"不能给供应商看）。
        //排除发生在 vuexFieldConfigs，所以表头和"自定义列"弹窗都取不到这些列。
        excludeFieldKeys: {
            type: Array,
            default: () => []
        },
        //禁用行编辑按钮
        inlineActionsDisabled: {
            type: Boolean,
            default: false
        },
        //启用行选择按钮，用于在modal中把某一行的数据返回给父组件
        selectActionEnable: {
            type: Boolean,
            default: false
        },
        //启用显示详情按钮
        showDetail: {
            type: Boolean,
            default: false
        },
        //启用表头
        showTitle: {
            type: Boolean,
            default: false
        },
        //表头
        title: {
            type: String,
            default: ""
        },
        //启用行自定义按钮插槽（最后一列）
        withCustomRowActions: {
            type: Boolean,
            default: false
        },
        //行自定义按钮插槽列名（最后一列）
        customRowActionsText: {
            type: String,
            default: "扩展功能"
        },
        //启用行自定义按钮插槽（第一列）
        withCustomRowActionsFirstColumn: {
            type: Boolean,
            default: false
        },
        //行自定义按钮插槽列名（第一列）
        customRowActionsTextFirstColumn: {
            type: String,
            default: "扩展功能"
        },
        //当前选中行，变色用
        selectedRowId: {},
        isUsingCustomMethod: {
            type: Boolean,
            default: false
        },
        isEditCard: {
            type: Boolean,
            default: false
        },
        disableCheckedColorChange: {
            type: Boolean,
            default: false
        },
        modalCheckEnable: {
            type: Boolean,
            default: false
        },
        detailInlineButtonType: {
            type: String,
            default: "showEntity"
        },
        listenAddNewEntityEvent: {
            type: Boolean,
            default: false
        },
        customFormClass: {
            type: Function,
            default: null
        },
        useCustomFieldsDefaultFlag: {
            type: Boolean,
            default: true
        },
        enableOverCheck: {
            type: Boolean,
            default: false
        },
        enableChartGenerator: {
            type: Boolean,
            default: false
        },
        //关闭表头列的列宽可拖拽
        disableColumnResize: {
            type: Boolean,
            default: false
        },
        //格式化td显示内容
        formatCellValue: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            modalEditValue: "",
            modelEditColumnLabel: "",
            modelCustomizationLabel: "Customization",
            modelEditColumnKey: "",
            modelEditMode: {},
            modalEditRow: null,
            entityObject: {},
            onDeleting: false,
            tableColumnsVersion: 1,
            isOverCheckTableViewing: false,
            // multipleSelection: [],
            importLoading: false,
            //when sort querying
            sortLoading: 0,
        };
    },
    // provide() {
    //   return {
    //     vuexFieldConfigs: this.vuexFieldConfigs,
    //     tableColumns: this.tableColumns,
    //     localstorageFieldConfigsKey: this.localstorageFieldConfigsKey,
    //     tableColumnsReload: this.tableColumnsReload
    //   }
    // },
    computed: {
        localstorageFieldConfigsKey() {
            return `em-table-custom-fields-${this.entity}-${this.$_emCustomVuexMixin_vo}`
        },
        customVuexName() {
            // slice(0,-2) 是将后缀Vo去掉
            return this.$_emCustomVuexMixin_vo === "rows" ? "" : this.$_emCustomVuexMixin_vo.slice(0, -2)
        },
        vuexFieldConfigs() {
            let temp = this.inlineActionsDisabled
                ? this.$_emCustomVuexMixin_voConfigs
                : this.$_emCustomVuexMixin_entityConfigs
            //addition columns
            let addition = _getAdditionColumnsByKey(this.entity, this.$_emCustomVuexMixin_vo);
            if (addition) {
                temp = temp.concat(addition);
            }
            if (this.excludeFieldKeys && this.excludeFieldKeys.length > 0) {
                temp = temp.filter(f => this.excludeFieldKeys.indexOf(f.key) === -1);
            }
            return temp;
        },
        //表头数据
        tableColumns() {
            //通过让计算属性绑定data，来控制计算属性的刷新。
            if (this.tableColumnsVersion) {
            }
            //行编辑时就不区分VO和SaveForm了，看到的就是要保存的，所以
            //如果不是行编辑模式，就取gridFields作为tableColumns（后端的VO注解），如果是行编辑，就取entityFormConfigs作为tableColumns（后端的SaveForm注解）
            let gridFields = this.vuexFieldConfigs
            //如果曾经自定义过，就用自定义字段顺序循环取重新取一下字段名
            if (localStorage[this.localstorageFieldConfigsKey]) {
                let localStorageKeyArray = JSON.parse(localStorage[this.localstorageFieldConfigsKey])
                let customGridFields = []
                localStorageKeyArray.forEach(lsf => {
                    gridFields.find(f => f.key === lsf.key) && customGridFields.push(gridFields.find(f => f.key === lsf.key))
                })
                gridFields = customGridFields
            }
            // console.log(gridFields)
            // 如果不显示详情,并且未自定义列，就去掉详情列
            if (!this.showDetail && !localStorage[this.localstorageFieldConfigsKey]) {
                gridFields = gridFields.filter(f => !f.isDetail);
            }
            //表头对象
            let columnsData = [];
            //行选择框
            if (!this.checkboxColumnDisabled) {
                columnsData.push(checkboxField);
            }
            //行首插槽
            if (this.withCustomRowActionsFirstColumn) {
                columnsData.push(customRowActionsFirstColumnField);
            }
            //行数据选择按钮
            if (this.selectActionEnable) {
                columnsData.push(selectActionField);
            }
            //插入从model中取出的表头字段
            columnsData = columnsData.concat(gridFields);
            //如果未禁用行编辑或未禁用显示详情按钮,就在最后面增加actionField
            if (this.isInlineActionDisplay()) {
                columnsData.push(actionField);
            }
            return columnsData;
        },
        //表中数据
        rows: {
            get() {
                if (this.isOverCheckTableViewing) {
                    return this.$refs.overCheck.checkedRows();
                }
                return this.$_emCustomVuexMixin_voStore;
            },
            set(value) {
                // let loadState_cap_first = emUtils.toCapFirst(this.loadState)
                // this.$store.commit(`${this.entity}/set${loadState_cap_first}`, value);
                this.$_emCustomVuexMixin_voStore = value
            }
        },
        //新增数据
        newRows: {
            get() {
                let newRows = this.$_emCustomVuexMixin_vo === "rows" ? "newRows"
                    : `newRows${emUtils.toCapFirst(this.$_emCustomVuexMixin_vo)}`
                return this.$store.state[this.entity][newRows];
            }
        },
        //编辑中数据
        editingRows: {
            get() {
                let editingRows = this.$_emCustomVuexMixin_vo === "rows" ? "editingRows"
                    : `editingRows${emUtils.toCapFirst(this.$_emCustomVuexMixin_vo)}`
                return this.$store.state[this.entity][editingRows];
            }
        },
        checkedItemsVuexStateName: {
            get() {
                return this.$_emCustomVuexMixin_vo === "rows" ? "checkedItems"
                    : `checkedItems${emUtils.toCapFirst(this.$_emCustomVuexMixin_vo)}`
            }
        },
        //选中数据ID，
        checkedItems: {
            get() {
                return this.$store.state[this.entity][this.checkedItemsVuexStateName];
            },
            set(value) {
                this.$store.commit(`${this.entity}/set${emUtils.toCapFirst(this.checkedItemsVuexStateName)}`, value);
            }
        },
        //选中数据对象列表
        checkedItemsRows: {
            get() {
                return this.rows.filter(f => this.checkedItems.includes(f.id))
            }
        },
        //当前页
        currentPage: {
            get() {
                return this.$store.state[this.entity].currentPage;
            },
            set(value) {
                this.$store.commit(this.entity + "/setCurrentPage", value);
            }
        },
        //每页记录数
        rowsPerPage: {
            get() {
                return this.$store.state[this.entity].fixedFilter.numRegPag;
            },
            set(value) {
                this.$store.commit(this.entity + "/setRowsPerPage", value);
                this.$store.commit(this.entity + "/setCurrentPage", 1);
            }
        },
        //总记录数
        totalRows() {
            return this.$store.state[this.entity].fixedFilter.totalReg;
        },
        //新数据对象
        newEntity() {
            return this.$_emCustomVuexMixin_newEntity()
        },
        //无记录提示
        showNoResultAlert() {
            return this.$store.state[this.entity][`showNoResultAlert${this.getVoStateAsSuffix()}`];
        },
        itemLimitationAlert: {
            get() {
                return this.$store.state[this.entity].itemLimitationAlert;
            },
            set(value) {
                this.$store.commit(this.entity + "/setItemLimitationAlert", value);
            }
        },
        //排序
        sortingBy: {
            get() {
                return this.$store.state[this.entity].sortingBy;
            },
            set(value) {
                this.$store.commit(this.entity + "/setSortingBy", value);
            }
        },
        parentLevel: {
            get() {
                let levelHolder = this.$store.state[this.entity].filterHolder["levelFilter"]
                if (levelHolder) {
                    return levelTreeUtil.getParentLevel(levelHolder)
                }
                return null
            }
        },
        pathType() {
            return this.$route.query.pathType
        },
        tableCoverClass() {
            let tempList = [];
            tempList.push(this.disableCheckedColorChange ? 'table-striped' : '');
            tempList.push(this.disableColumnResize ? '' : 'table-cover');
            return tempList.join(' ');
        },
    },
    methods: {
        toggleAll(checked) {
            // let setCheckedItems = `set${emUtils.toCapFirst(this.checkedItemsVuexStateName)}`
            if (!checked) {
                // this.$store.commit(setCheckedItems, []);
                this.checkedItems = []
                return;
            }

            let auxVector = [];
            for (let i in this.rows)
                auxVector.push(this.rows[i].id);

            // this.$store.commit(setCheckedItems, auxVector);
            this.checkedItems = auxVector
        },
        //显示详情
        showEntity(row) {
            this.entityObject = row;
            // console.log("this is emTable.showEntity()")
            // console.log(this.entityObject)
            this.$refs["modalEntityViewer"].showModal(this.entityObject);
        },
        //显示自定义列
        showCustomization() {
            this.$refs["modalCustomization"].show();
        },
        //弹出编辑（目前没用到）
        showModalEditValue(mode, row, col) {
            this.modelEditMode = mode;
            this.modalEditValue = row[col.key];
            this.modelEditColumnLabel = col.label;
            this.modelEditColumnKey = col.key;
            this.modalEditRow = row;
            if (mode.action === "edit") {
                this.$refs.modalEditor.show();
            } else {
                this.$refs.modalViewer.show();
            }
        },
        //决定表的编辑和删除按钮是否要禁用
        actionDisabled(type) {
            // 删除按钮在一条记录都没选的时候禁用
            if (type === "delete") {
                return this.checkedItems.length === 0;
            }
            // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
            else {
                return this.checkedItems.length !== 1;
            }
        },
        //添加新行：行编辑
        addRow() {
            //新行数为0时才执行
            if (this.newRows.length === 0) {
                //用model中的构造函数创建newRow
                let newRow = this.$_emCustomVuexMixin_newEntity()
                //存入vuex
                this.$store.commit(this.entity + "/addNewRow" + this.getVoStateAsSuffix(), newRow);
            }
        },
        //保存新建记录
        saveAddedRow(row) {
            //存入vuex
            this.$store.commit(`${this.entity}/set${emUtils.toCapFirst(this.$_emCustomVuexMixin_entity)}`, row);
            //验证通过后才执行
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    //保存记录到数据库
                    this.$store.dispatch("emBase/emBaseSaveInline", {
                        entity: this.entity,
                        entityState: this.$_emCustomVuexMixin_entity
                    }).then(() => {
                        this.cancelAddedRow(row);
                        this.clearEditingRows();
                    });
                }
            });
        },
        // 保存编辑行
        saveEditedRow(row) {
            const saveEntity = this.editingRows.filter(r => r.id === row.id)[0];
            //存入vuex
            this.$store.commit(`${this.entity}/set${emUtils.toCapFirst(this.$_emCustomVuexMixin_entity)}`, saveEntity);
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    if (this.isUsingCustomMethod) {
                        console.log(this.formulaDetailSave);
                        const formulaDetailSaveName = this.formulaDetailSave;
                        this.$parent[formulaDetailSaveName](this.entity);
                        this.cancelRowEdit(row);
                    } else {
                        this.$store.dispatch("emBase/emBaseSaveInline", {
                            entity: this.entity,
                            entityState: this.$_emCustomVuexMixin_entity
                        }).then(() => {
                            //todo 这里赋值了，为啥保存后，rows没变化
                            this.rows = this.rows.map(v => {
                                if (v.id === row.id) {
                                    return {...saveEntity};
                                } else {
                                    return v;
                                }
                            });
                        });
                        this.cancelRowEdit(row);
                    }

                    // this.newRows.pop();
                }
            });
        },
        getVoStateAsSuffix() {
            //等于rows，就没有后缀，否则就首字母大写当做后缀
            return this.$_emCustomVuexMixin_vo === "rows" ? "" : emUtils.toCapFirst(this.$_emCustomVuexMixin_vo)
        },
        clearEditingRows() {
            let voState = this.$_emCustomVuexMixin_vo ? emUtils.toCapFirst(this.$_emCustomVuexMixin_vo) : ""
            this.$store.commit(this.entity + "/clearEditingRows" + this.getVoStateAsSuffix());
        },
        cancelAddedRow(row) {
            this.$store.commit(this.entity + "/removeNewRow" + this.getVoStateAsSuffix(), row);
        },
        cancelRowEdit(row) {
            this.$store.commit(this.entity + "/removeEditingRow" + this.getVoStateAsSuffix(), row);
        },
        editRow(row) {
            this.$store.commit(this.entity + "/addEditingRow" + this.getVoStateAsSuffix(), row);
        },
        handleDelete() {
            this.onDeleting = true
            this.emBaseDelete({
                entity: this.entity,
                voState: this.$_emCustomVuexMixin_vo
            }).finally(() => this.onDeleting = false)
        },
        delRow(row) {
            this.onDeleting = true
            //modify on 2019-10-9 by yujiabei
            let data = {entity: this.entity, id: row.id};
            this.$store.dispatch("emBase/emBaseDeleteInline", data).finally(() => this.onDeleting = false)
            // let modifiedRows = this.rows.filter(x => x.id !== row.id);
            // // this.$store.commit(this.entity + "/setRows", modifiedRows);
            // this.rows = modifiedRows
        },
        getDetailInlineButtonType(row) {
            if (this.detailInlineButtonType !== 'showEntity') {
                let type = this.$parent.getDetailInlineButtonType(row);
                console.log('按钮类型： ' + type);
                return type;
            }

            return this.detailInlineButtonType;
        },
        saveModalEditValue() {
            if (this.modelEditMode.scope === "edit") {
                this.$store.commit(this.entity + "/setRow" + this.getVoStateAsSuffix(), {
                    row: this.modalEditRow,
                    key: this.modelEditColumnKey,
                    newValue: this.modalEditValue
                });
            } else {
                this.$store.commit(this.entity + "/setNewRow" + this.getVoStateAsSuffix(), {
                    row: this.modalEditRow,
                    key: this.modelEditColumnKey,
                    newValue: this.modalEditValue
                });
            }
        },
        saveCustomization() {
            //todo:
        },
        //todo mmfTable多出来的changeEntityAttribute，在emTable中没有被用到
        // 里面有对深层属性的赋值和对col.form.onChangeDispatchAction的dispatch，暂时我这里先不动。感觉用不上，但先记录一下
        changeEntityAttribute(col, row, $event) {
            let splited = col.key.split(".");
            let key = col.key;
            let newValue = $event;
            if (splited.length > 1) {
                let baseAttribute = this.entityObject[splited[0]];

                baseAttribute =
                    baseAttribute !== "" ? Object.assign({}, baseAttribute) : {};

                let newAttribute = baseAttribute;
                for (let i = 1; i < splited.length; i++) {
                    let iKey = splited[i];
                    newAttribute[iKey] = i === splited.length - 1 ? $event : {};
                    newAttribute = newAttribute[iKey];
                }

                key = splited[0];
                newValue = baseAttribute;
            }

            this.$store.commit(this.entity + "/setRow", {
                row,
                key,
                newValue
            });
            if (col.form.type === "entitySelect") {
                let id = $event ? $event : 0;
                if (col.form.onChangeDispatchAction) {
                    for (let i in col.form.onChangeDispatchAction) {
                        this.$store.dispatch(col.form.onChangeDispatchAction[i], {
                            id,
                            mainEntity: this.entity,
                            type: "entity"
                        });
                    }
                }
            }
        },
        changeNewEntityAttribute(col, row, $event) {
            this.$store.commit(this.entity + "/setNewRow" + this.getVoStateAsSuffix(), {
                row: row,
                key: col.key,
                newValue: $event
            });
        },
        changeEditEntityAttribute(col, row, $event) {
            this.$store.commit(this.entity + "/setRow" + this.getVoStateAsSuffix(), {
                row: row,
                key: col.key,
                newValue: $event
            });
        },
        //判断row是否为编辑状态
        isRowEditing(row) {
            // 如果是弹出选择，一律视为非编辑状态
            if (this.isModal) {
                return false;
            }
            // 如果id为空，视为编辑状态（新增）
            else if (row.id == null) {
                return true;
            }
            // 如果id在this.editingRows中，也认为是编辑状态（修改）
            let result = this.editingRows.some(r => r.id === row.id);
            //用编辑数据覆盖查询数据   2019-10-9 yujiabei
            // if(result){
            //     console.log(JSON.parse(this.editingRows.filter(r => r.id == row.id)[0]))
            //     row = this.editingRows.filter(r => r.id == row.id)[0]
            //     console.log(JSON.parse(row))
            // }
            return result;
        },
        //决定排序图标的显示
        getSortedState(col) {
            let sortObject = this.sortingBy.find(x => x.column === col);
            let icon = "";
            if (sortObject) {
                if (sortObject.order === "asc") icon = "fas fa-sort-up";
                else {
                    icon = "fas fa-sort-down";
                }
            } else {
                icon = "none";
            }

            return icon;
        },
        getProcessingType(row, col) {
            if (row[col.key] === "P") {
                return "running";
            } else if (row[col.key] === "S") {
                return "success";
            } else if (row[col.key] === "E") {
                return "error";
            } else if (row[col.key] === "C") {
                return "error";
            }
            return "error";
        },
        getLogAvailable(row, col) {
            return !!row[col.key];

        },
        downloadLog(row) {
            console.log(row);
            this.$store.dispatch("base/MMFDownloadLog", row.id);
        },
        //获取object中的key值，key支持".",可以获取到好几层之内的值
        visitateProperty(o, s) {
            s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
            s = s.replace(/^\./, ""); // strip a leading dot
            var a = s.split(".");
            for (var i = 0, n = a.length; i < n; ++i) {
                var k = a[i];
                if (k in o) {
                    o = o[k];
                } else {
                    return;
                }
            }
            return o;
        },
        getColumnOriginKey(column) {
            let translateFrom = column.key;
            //获取字段的origin key
            if (column.hasOwnProperty("translateFromField")) {
                translateFrom = column.translateFromField;
            }
            return translateFrom;
        },
        // 字段排序，一次只能用一个字段排序，不支持联合排序
        //记录表头按下时的列宽，供 sortColumn 判断本次交互是否为列宽拖拽
        onHeaderMouseDown(e) {
            this._headerResizeFromWidth = e && e.currentTarget ? e.currentTarget.offsetWidth : null;
        },
        sortColumn(column, e) {
            //列宽拖拽(resize)结束也会触发 th 的 click：若本次交互改变了列宽，则视为拖拽，跳过排序
            if (e && e.currentTarget && this._headerResizeFromWidth != null
                && Math.abs(e.currentTarget.offsetWidth - this._headerResizeFromWidth) > 1) {
                this._headerResizeFromWidth = null;
                return;
            }
            if (column.hasOwnProperty("sortable") && column.sortable === true) {
                this.sortLoading++;
                let translateFrom = this.getColumnOriginKey(column);
                //取当前排序字段
                let allSortingColumns = this.sortingBy;
                //判断column是否已经是当前排序字段
                let item = allSortingColumns.find(item => item.column === translateFrom);
                if (item) {
                    //如果已经是排序字段了，那asc就变成desc，desc就变为非排序字段
                    if (item.order === "asc") {
                        //直接改会触发[vuex] do not mutate vuex store state outside mutation handlers异常
                        // item.order = "desc";
                        allSortingColumns = [{column: translateFrom, order: "desc"}];
                    } else {
                        allSortingColumns = [];
                    }
                }
                //如果不是，就把column用asc加入为当前排序字段
                else {
                    allSortingColumns = [{column: translateFrom, order: "asc"}];
                }
                //把sortingBy存回vuex
                this.sortingBy = allSortingColumns;
                // this.$store.commit(this.entity + "/setSortingBy", allSortingColumns);
                //把vuex中的开始页重新设为1
                // this.$store.commit(this.entity + '/setCurrentPage', 1);
                //查询
                this.emBaseQueryByFilterSearch({
                    entity: this.entity,
                    filterState: this.$_emCustomVuexMixin_filter,
                    loadState: this.$_emCustomVuexMixin_vo,
                    queryApi: this.queryApi
                }).finally(() => this.sortLoading--);
                this.$emit("sortByColumn")
            }
        },
        isChecked(row) {
            return this.checkedItems.some(rowId => rowId === row.id);
        },
        //entity弹出选择的选中事件
        selectRow(row) {
            this.$emit("entitySelected", row);
        },
        emitEvent(emitName, data) {
            this.$emit(emitName, data);
        },
        gotoGrandParentLevel() {
            let grandParentId = levelTreeUtil.getGrandParentId(this.$store.state[this.entity].filterHolder["levelFilter"])
            commonViewsUtil.gotoHolderList(this, this.entity, {
                parentIdFilter: grandParentId,
                levelFilter: this.parentLevel
            }, {parentId: grandParentId})
        },
        getRowClass(rowId) {
            if (this.selectedRowId === rowId) {
                return "success"
            }
            return "primary"
        },
        //如果是editCard，就变更css
        getFixedHeaderCantainerClass() {
            if (this.isEditCard || this.isModal) {
                return 'fixed-header-container-edit-card'
            }
            return 'fixed-header-container'
        },
        //如果是editCard，就变更css
        getFixedHeaderTopDivClass() {
            if (this.isEditCard) {
                return 'fixed-header-top-div-edit-card'
            }
            return 'fixed-header-top-div'
        },
        isCustomRowActionsDisplay() {
            return this.withCustomRowActions
        },
        isInlineActionDisplay() {
            return !this.detailInlineButtonDisable || !this.inlineActionsDisabled
        },
        showModalSelectorByNewRow(col, row) {
            this.$emit("showModalSelectorByNewRow", col, row);
        },
        showModalMultipleSelectorByNewRow(col, row) {
            this.$emit("showModalMultipleSelectorByNewRow", col, row);
        },
        showModalSelectorByEditRow(col, row) {
            this.$emit("showModalSelectorByEditRow", col, row);
        },
        showModalMultipleSelectorByEditRow(col, row) {
            this.$emit("showModalMultipleSelectorByEditRow", col, row);
        },
        getEditingRowById(id) {
            return this.editingRows.filter(f => f.id === id)[0]
        },
        doPagination() {
            this.$emit("doPagination")
        },
        tableExport() {
            this.$refs.exportConfirm.show();
        },
        tableImport() {
            this.$refs.importConfirm.show();
        },
        openCustomization() {
            this.$refs.Customization.open();
        },
        tableColumnsReload() {
            this.tableColumnsVersion++
        },
        customClass(col, row) {
            if (col && row) {
                if (col.form && col.form.customClass) {
                    return col.form.customClass(row);
                } else if (this.customFormClass != null) {
                    return this.customFormClass(col, row);
                }
            }
            return ""
        },
        //el table的行多选
        handleSelectionChange(val) {
            this.checkedItems = [...val.map(m => m.id)]

            // this.multipleSelection = val;
        },
        //el table的行选择
        handleSelect(selection, row) {
            this.emBaseSelectRowForEl({item: row, entity: this.entity, entityState: this.$_emCustomVuexMixin_entity})
        },
        //可自定义导出报表的url
        getTableExportUrl() {
            return this.tableExportUrl ? this.tableExportUrl : this.queryApi;
        },
        //el table的后端排序
        handleSortChange(orderBy) {
            // console.log(orderBy)
            let column = this.tableColumns.find(f => f.key === orderBy.prop)
            if (column.hasOwnProperty("sortable") && column.sortable === true) {
                //取当前排序字段
                let allSortingColumns = [];
                if (orderBy.order === "ascending") {
                    allSortingColumns = [{column: column.key, order: "asc"}];
                } else if (orderBy.order === "descending") {
                    allSortingColumns = [{column: column.key, order: "desc"}];
                }
                //把sortingBy存回vuex
                this.sortingBy = allSortingColumns;
                // this.$store.commit(this.entity + "/setSortingBy", allSortingColumns);
                //把vuex中的开始页重新设为1
                // this.$store.commit(this.entity + '/setCurrentPage', 1);
                //查询
                this.emBaseQueryByFilterSearch({
                    entity: this.entity,
                    filterState: this.$_emCustomVuexMixin_filter,
                    loadState: this.$_emCustomVuexMixin_vo,
                    queryApi: this.queryApi
                })
                this.$emit("sortByColumn")
            }
        },
        //el table的筛选
        getColumnFilters(key) {
            //如果有options，直接返回options
            let col = this.tableColumns.find(f => f.key === key)
            if (col && col.form.options) {
                return col.form.options
            }
            //否则把所有值取出来做成set，再转成option类型的数组
            else {
                return [...new Set(this.rows.map(m => m[key]))].map(m => {
                    return {text: m, value: m}
                })
            }
        },
        filterHandler(value, row, column) {
            console.log(value)
            const property = column['property'];
            console.log(row[property])
            return row[property] + "" === value + ""
        },
        clickAddNewEntityButton() {
            if (this.listenAddNewEntityEvent) {
                this.$emit('addNewEntity');
            } else {
                this.gotoAddNewEntity();
            }
        },
        clickEditEntityButton() {
            this.emBaseEdit({
                entity: this.entity,
                entityState: this.$_emCustomVuexMixin_entity,
                fromPathType: this.pathType
            })
        },
        gotoAddNewEntity() {
            this.emBaseNew({
                entity: this.entity,
                entityState: this.$_emCustomVuexMixin_entity,
                fromPathType: this.pathType
            });
        },

        overCheckButtonClick() {
            if (this.isOverCheckTableViewing) {
                this.isOverCheckTableViewing = false;
            } else {
                this.addCheckedRowsToOverCheck();
            }
        },
        addCheckedRowsToOverCheck() {
            this.$refs.overCheck.addRows(this.checkedItemsRows);
        },
        getOverCheckedIds() {
            return this.$refs.overCheck.checkedIds();
        },

        setNewRowValue(key, value) {
            if (this.newRows.length === 1) {
                this.changeNewEntityAttribute({key: key}, this.newRows[0], value);
            }
        },

        openChartGenerator() {
            if (this.enableChartGenerator) {
                this.$refs.table_chart_configure_modal.showModal();
                let temp = this.rows;
                if (this.checkedItemsRows.length > 0) {
                    temp = this.checkedItemsRows;
                }
                if (this.$refs.overCheck.checkedRows().length > 0) {
                    temp = this.$refs.overCheck.checkedRows();
                }
                temp = JSON.parse(JSON.stringify(temp));//avoid infect origin data
                for (let row of temp) {
                    for (let key of Object.keys(row)) {
                        let refs = this.$refs[`view_cell_${row.id}_${key}`];
                        if (refs) {
                            let cell = refs[0];
                            if (cell) {
                                row[key] = cell.getViewedValue();
                            }
                        }
                    }
                }
                this.$nextTick(() => this.$refs.table_chart.initializeData(this.tableColumns, temp, this.entity));
            }
        },
        //获取表头列的样式
        getTableColumnClass(col) {
            if (col.isActionField || col.isControlField) {
                return '';
            } else if (!this.disableColumnResize) {
                return 'table-column-cover';
            }
            return '';
        },

        ...
            mapActions("base", [
                "MMFselectRow",
                "MMFLoadRowsSearch",
                "MMFSaveInline",
                "MMFNew",
                "MMFEdit",
                "MMFDelete",
                "MMFExport"
            ]),
        ...
            mapActions("emBase", [
                "emBaseNew",
                "emBaseEdit",
                "emBaseSelectRow",
                "emBaseSelectRowForEl",
                "emBaseDelete",
                "emBaseDeleteInline",
                "emBaseQueryByFilterSearch"
            ])
    }
};
</script>

<!--针对editCard，定制一些css-->
<style lang="scss" scoped>
.fixed-header-container-edit-card {
    overflow: auto;
}

.fixed-header-container-edit-card table {
    border-spacing: 0;
    // width: 100%;
}

.fixed-header-container-edit-card td,
.fixed-header-container-edit-card th {
    padding: 10px 6px;
    background-color: #FFF;
    z-index: 1;
}

.fixed-header-container-edit-card th {
    height: 0;
    line-height: 0;
    padding-top: 0;
    padding-bottom: 0;
    color: transparent;
    border: none;
    white-space: nowrap;
    position: sticky;
    top: 0;
}

.fixed-header-container-edit-card th div {
    // position: absolute;
    // background: transparent;
    color: black;
    padding: 9px 25px;
    top: 0;
    margin-left: -25px;
    line-height: normal;
}

.fixed-header-container-edit-card th:first-child div {
    border: none;
}

.fixed-header-top-div-edit-card {
    position: relative;
}

.td-cover {
}

.td-cover td {
    background-color: transparent !important;
}

.table-cover {
    width: max-content;
    min-width: 100%;
}

.table-column-cover {
    overflow: auto;
    resize: none;            /* 默认隐藏列宽拖拽手柄 */
}

/* 悬浮表头时才显示 resize 手柄 */
.table-column-cover:hover {
    resize: horizontal;
}

/* 表头高度收紧到 fit-content：覆盖全局 .fixed-header-container th div 的 9px 纵向内边距 */
.fixed-header-container th div,
.fixed-header-container-edit-card th div {
    padding-top: 3px;
    padding-bottom: 3px;
}
</style>
